fx.service( class GoogleConvertService extends fx.Service
{
    constructor(model)
    {
        super();

        this.model = model.creationModel;

        this.on("event", this._dataEvent, this.model);
        this._reset();
    }

    convert(photos)
    {
        this.queue = this.queue.concat(photos);

        this._process();
    }

    _dataEvent(e)
    {
        switch(e.detail.event.type)
		{
            case "offline":
                this._reset();
            break;
        }
    }

    _process()
    {
        if (this.queue.length == 0)
            this.trigger("google-convert-finished", this.receivedFiles);
        else
        if (this.currentRequest.length == 0)
        {
            for(let i = 0; i < 5 && this.queue.length > 0; i++) // we send picture per 5
                this.currentRequest.push(this.queue.shift());

            this._send();
        }
    }

    _send()
    {
        let photos = [];

        for (let i = 0; i < this.currentRequest.length; i++)
		{
			let photo = { 
				media_id: this.currentRequest[i].id,
				url: this.currentRequest[i].fullSize_url ? this.currentRequest[i].fullSize_url : this.currentRequest[i].baseUrl
			};

			photos.push(photo);
		}
       
        // depending we are using config or editor
        let creation = this.model.creationModel || this.model.creation;

		this.post(fx.service("MediasUploader").uploadURL(),  
        { 
            creation_id:  creation.id,
            mediatype : "google-photos",
            files : photos
        }, 
        this._onSend, 
        {timeout : 0 } 
      );

      let progress = Math.ceil( (this.done.length / (this.queue.length + this.done.length))  * 100);
      if (isNaN(progress))
        progress = 1;
        //this.model.event("google-selected-photos-sent", Math.ceil( (this.done.length / (this.queue.length + this.done.length))  * 100) ); // TODO : send progress
      this.trigger("google-converting", progress.toString() );
    }

    _onSend(data)
    {
        if (this.currentRequest.length == 0)
            return;

        if (data.error || data.success === false)
        {
            if (this.tries < 5)
            {
                this.queue = this.queue.concat(this.currentRequest);
                this.currentRequest = [];
                this.tries++;
                this._process();
            }
            else
            {
                this.trigger("google-convert-finished", {error : true});
                this._reset();
            }
               
        }
        else
        {
            for(let i = 0; i < this.currentRequest.length; i++)
            {
                if(data[i])
                {
                    let {baseUrl, fullSize_url, id, mediaMetadata, thumb} = this.currentRequest[i]; 

			        if (data[i])
                        this.receivedFiles.push( { 
                                                server_url: data[i].url,
                                                baseUrl,
                                                fullSize_url : fullSize_url,
                                                id,
                                                thumb,
                                                metaData : mediaMetadata
                                            });
                }
            }
               
            
            this.done = this.done.concat(this.currentRequest);
            this.currentRequest = [];
            this._process();
        }
    }


    _reset()
    {
        this.queue = [];
        this.currentRequest = [];
        this.done = [];
        this.receivedFiles = [];
        this.tries = 0;
    }
    //
});
    